import React, { type HTMLAttributes, useEffect } from 'react';

import { Link } from 'react-router-dom';

import { Typography } from '../../../DesignSystem';
import { WishlistThumbnail } from '../../../Wishlist/AddToWishlistModal/WishlistThumbnail';

import {
    StyledSearchListItemSpacer,
    StyledSearchListItemWrapper,
    StyledThumbnail,
    StyledThumbnailDoubleWrapper,
    StyledThumbnailFirstPiece,
    StyledThumbnailMulti,
    StyledThumbnailSecondPiece,
    StyledThumbnailThirdPiece,
    StyledThumbnailTripleWrapper,
    StyledThumbnailWrapper,
} from './styles';

interface WishlistItemProps extends HTMLAttributes<HTMLDivElement> {
    id: string;
    name: string;
    thumbnails: string[];
    focused?: boolean;
    onFocused?: (link: string) => void;
}

export function WishlistItem({ id, name, thumbnails, focused, onFocused, ...rest }: WishlistItemProps) {
    const slicedThumbnails = thumbnails?.slice(0, 3);
    const thumbnailsCount = slicedThumbnails?.length;

    const link = `/wishlists/${id}`;

    useEffect(() => {
        focused && onFocused?.(link);
    }, [focused, link, onFocused]);

    const thumbnailMarkup = thumbnails ? (
        thumbnailsCount < 2 ? (
            <StyledThumbnail src={slicedThumbnails[0]} />
        ) : thumbnailsCount === 2 ? (
            <StyledThumbnailDoubleWrapper>
                <StyledThumbnailFirstPiece>
                    <StyledThumbnailMulti src={slicedThumbnails[0]} />
                </StyledThumbnailFirstPiece>
                <StyledThumbnailSecondPiece>
                    <StyledThumbnailMulti src={slicedThumbnails[1]} />
                </StyledThumbnailSecondPiece>
            </StyledThumbnailDoubleWrapper>
        ) : (
            <StyledThumbnailTripleWrapper>
                <StyledThumbnailFirstPiece>
                    <StyledThumbnailMulti src={slicedThumbnails[0]} />
                </StyledThumbnailFirstPiece>
                <StyledThumbnailSecondPiece>
                    <StyledThumbnailMulti src={slicedThumbnails[1]} />
                </StyledThumbnailSecondPiece>
                <StyledThumbnailThirdPiece>
                    <StyledThumbnailMulti src={slicedThumbnails[2]} />
                </StyledThumbnailThirdPiece>
            </StyledThumbnailTripleWrapper>
        )
    ) : (
        <StyledThumbnailWrapper>
            <WishlistThumbnail style={{ width: 36, height: 36, gap: 2 }} />
        </StyledThumbnailWrapper>
    );
    return (
        <Link to={link}>
            <StyledSearchListItemWrapper {...rest} $focused={focused}>
                {thumbnailMarkup}
                <Typography variant="h3" type="label" size={14} weight="700">
                    {name}
                </Typography>
                <StyledSearchListItemSpacer />
            </StyledSearchListItemWrapper>
        </Link>
    );
}
